import AsyncStorage from "@react-native-async-storage/async-storage";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

export enum ThemeSettings {
  System = "system",
  Light = "light",
  Dark = "dark",
}

export interface ThemeStore {
  themeChoice: ThemeSettings | undefined;
  setThemeChoice: (theme: ThemeSettings) => void;
}

export const useThemeStore = create<ThemeStore>()(
  persist(
    (set) => ({
      themeChoice: undefined,
      setThemeChoice: (themeChoice) => set({ themeChoice }),
    }),
    {
      name: "theme-storage",

      // Use the AsyncStorage from react-native-async-storage/async-storage instead of our wrapper
      // which doesn't have the types expected by the persist middleware
      storage: createJSONStorage(() => AsyncStorage),
    },
  ),
);
